module.exports = __webpack_public_path__ + "img/rating-page-slider-mobile-2.c0126afc.png";